import { LoadingButton } from '@mui/lab';
import { Box, Button, Card, CircularProgress, DialogContent, Tooltip, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearFormValues, fetchReportOptions, updateActiveStep } from '../../../../redux/slices/reports';
import Iconify from '../../../../reusable-components/iconify';
import { useSnackbar } from '../../../../reusable-components/snackbar';
import ReportSelectSpecificationsStep from '../ReportSelectSpecificationsStep';
import ReportSelectTypeStep from '../ReportSelectTypeStep';
import { getReportResultsMain, getEmptyFields } from '../ReportViewHelper';
import ReportResultTable from '../results/ReportResultTable';
import ReportTimeoutEmailPopup from '../results/ReportTimeoutEmailPopup';

export default function ReportsViewBasic() {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { loadingMainData, reportSpecificationOptions, loadingReportSpecificationOptions, loadingReportResults, downloadingReportResults, activeStep,
    formValues, selectedReportId } = useSelector((state) => state.reports?.data);

  const [openSidebar, setOpenSidebar] = useState(true);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [openTimeoutSendAsEmail, setOpenTimeoutSendAsEmail] = useState(false); 

  const hasEmptyField = useMemo(() => getEmptyFields(reportSpecificationOptions, formValues, selectedReportId, false), [reportSpecificationOptions, formValues])

  const startStepReportSpecificationOptions = () => {
    try {
      dispatch(fetchReportOptions(selectedReportId));
    } catch (error) {
      enqueueSnackbar(`Failed to fetch report specifications`, { variant: 'error' });
    }
  };

  const getReportResults = (download, sendAsEmail) => getReportResultsMain(selectedReportId, dispatch, setOpenTimeoutSendAsEmail, formValues, download, sendAsEmail); 
  return <Box sx={{ width: '100%', justifyContent: 'center', display: 'flex', alignItems: 'center', minHeight: 'calc(100vh - 250px)' }}>
    {activeStep !== 2 && <Card sx={{ maxWidth: showDatePicker ? '950px' : '600px', width: '100%', '& .MuiBackdrop-root': { backgroundColor: 'transparent' } }}>
      <Typography component="div" sx={{ display: 'flex', color: '#8cc53f', mb: -3, mt: 2 }}>
        {activeStep !== 0 && <Button
          title="Back"
          onClick={() => dispatch(updateActiveStep(activeStep - 1))}
          sx={{ color: 'gray', maxWidth: '20', visibility: activeStep === 0 ? 'hidden' : 'visible' }}
        >
          <Iconify icon="ic:baseline-arrow-back" width={20} height={20} />
        </Button>}
        <Box sx={{ flex: 1, textAlign: 'center', fontWeight: 'bold', fontSize: '20px', marginRight: activeStep !== 0 ? '60px' : 0 }}>
          {activeStep === 1 ? formValues.selectedReport?.name : 'New Report'}
        </Box>
      </Typography>

      <DialogContent>
        {!loadingMainData && !loadingReportSpecificationOptions ? <>
          {activeStep === 0 && <ReportSelectTypeStep />}
          {activeStep === 1 && <ReportSelectSpecificationsStep showDatePicker={showDatePicker} setShowDatePicker={setShowDatePicker} toggleStep="2" isScheduleReport={false} />}
          <Box display="flex" direction="row" justifyContent="center" alignItems="center">
            {activeStep === 0 && <Button
              title="Next"
              variant="contained"
              disabled={!formValues.selectedReport}
              onClick={startStepReportSpecificationOptions}
              sx={{ display: 'flex', justifyContent: 'center', mt: 2, px: 5 }}
            >
              Next
            </Button>}
            {activeStep === 1 && !downloadingReportResults && <Tooltip title={hasEmptyField.length > 0 ? `Missing ${hasEmptyField.join(', ')}` : ""}>
              <span>
                <LoadingButton
                  disabled={hasEmptyField.length > 0}
                  title="Generate Report"
                  variant="contained"
                  loading={loadingReportResults}
                  onClick={() => getReportResults(selectedReportId === 16 || selectedReportId === 20)}
                  endIcon={<Iconify icon={'tabler:send'} />}
                  sx={{ display: 'flex', justifyContent: 'center', mt: 2, px: 5 }}
                >
                  Generate Report
                </LoadingButton>
              </span>
            </Tooltip>}
          </Box>
        </> : <Box justifyContent="center" display="flex">
          <CircularProgress sx={{ alignSelf: 'center', margin: '50px' }} />
        </Box>}
      </DialogContent>
    </Card>}

    {openTimeoutSendAsEmail && <ReportTimeoutEmailPopup close={() => setOpenTimeoutSendAsEmail(false)} getReport={() => getReportResults(true, true)} />}
    {activeStep === 2 && <ReportResultTable
      back={() => dispatch(updateActiveStep(1))}
      backText="Modify Report"
      openSidebar={openSidebar}
      setOpenSidebar={setOpenSidebar}
      setOpenTimeoutSendAsEmail={setOpenTimeoutSendAsEmail}
      getReportResults={getReportResults}
      newReport={() => { dispatch(clearFormValues()); dispatch(updateActiveStep(0)); }}
    />}
  </Box>;
}